import * as React from 'react';

// tslint:disable:max-line-length

export const closeIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.4 5.586L1.45.636.036 2.05 4.986 7l-4.95 4.95 1.414 1.414 4.95-4.95 4.95 4.95 1.414-1.414L7.814 7l4.95-4.95L11.35.636 6.4 5.586"
    />
  </svg>
);
